import * as baja from "@nwebui/bajascript";

export default abstract class Converter {
  constructor(readonly nativeConverter: any) {}

  abstract convert(widget: baja.Component, target: baja.Component);
}

export type ConverterCtor = new (nativeConverter: any) => Converter;
